import { BasicButton } from "../theme/Component/BasicButton"
import { AdminService } from "../../core/services/AdminService";
import { InputDate } from "../theme/Input/InputDate";
import { useState } from "react";
import { _single } from "../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";

export const EraseTemTable = () => {
    const service = new AdminService();
    const [date, setDate] = useState<any>(_single.getCurrenDate());
    const errasetables = () => {
        
        toast.success("Eliminando tablas temporales...",{
            autoClose:5000,
            pauseOnHover:false,
        })
        service.executeTemporaryCleanningTables(date).subscribe(
            (resp:any)=>{
                _single.printOut(resp);
            }
        )
       
    }
    return (
        <div className="row">
            <div className="col-md-12">
                <h5>Eliminar tablas temporales</h5>                
            </div>
            <div className="col-md-6">                
                <InputDate value={date} name="Fecha" onChangeE={(e) => setDate(e)} />
            </div>
            <div className="col-md-12">
                <BasicButton useMargin icon="fa fa-trash" eventClick={errasetables}>
                    Eliminar
                </BasicButton>
            </div>
        </div>
    )
}